export default {
  hi_domain: 'https://www.xingzheai.cn',
  hi_host: 'www.xingzheai.cn',
  contact_email: 'chenhongyu@xingzhe.ai'
}
